import * as React from "react";

import { Button } from "@replohq/lattice/components/button/Button";
import { Separator } from "@replohq/lattice/components/separator/Separator";
import { ArrowRight } from "lucide-react";
import { formatPrice } from "replo-utils/lib/format";

export const LineItemRow = ({
  label,
  value,
}: {
  label: React.ReactNode;
  value: React.ReactNode;
}) => (
  <div className="flex items-center justify-between gap-2 text-sm">
    {label}
    <span className="shrink-0">{value}</span>
  </div>
);

export const BillingSeparator = () => (
  <Separator className="border-t border-dashed border-border bg-transparent" />
);

export const SubtotalRow = ({
  currentMonthlyPrice,
  newMonthlyPrice,
}: {
  currentMonthlyPrice: { amount: number; currency: string } | null;
  newMonthlyPrice: { amount: number; currency: string };
}) => (
  <LineItemRow
    label={<span className="font-medium text-muted">Total</span>}
    value={
      <span className="flex items-center gap-2">
        {currentMonthlyPrice && (
          <>
            <span className="font-medium text-muted">
              {formatPrice(currentMonthlyPrice)}/mo
            </span>
            <ArrowRight className="text-muted" size={16} />
          </>
        )}
        <span className="font-semibold">{formatPrice(newMonthlyPrice)}/mo</span>
      </span>
    }
  />
);

export const ConfirmFooter = ({
  buttonText,
  buttonVariant = "primary",
  onConfirm,
  isLoading,
  disabled,
  subtext,
}: {
  buttonText: string;
  buttonVariant?: "primary" | "secondary";
  onConfirm: () => void | Promise<void>;
  isLoading?: boolean;
  disabled?: boolean;
  subtext?: React.ReactNode;
}) => (
  <div className="flex flex-col gap-1">
    <Button
      variant={buttonVariant}
      size="base"
      className="w-full"
      onClick={() => void onConfirm()}
      loading={isLoading}
      disabled={disabled}
    >
      {buttonText}
    </Button>
    {subtext && <p className="text-xs text-placeholder text-left">{subtext}</p>}
  </div>
);
